/* eslint-disable react/prop-types */
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import EditIcon from '@mui/icons-material/Edit'

function FeatureActionsMenu({ anchorEl, onClose, onAddTenant, onRemoveTenant, onAddList, onEditFeature }) {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={onAddTenant}>
        <ListItemIcon>
          <PersonAddIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Adicionar tenant</ListItemText>
      </MenuItem>
      <MenuItem onClick={onRemoveTenant}>
        <ListItemIcon>
          <PersonRemoveIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Remover tenant</ListItemText>
      </MenuItem>
      <MenuItem onClick={onAddList}>
        <ListItemIcon>
          <GroupAddIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Adicionar lista de tenants</ListItemText>
      </MenuItem>
      {onEditFeature && (
        <MenuItem onClick={onEditFeature}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Editar feature</ListItemText>
        </MenuItem>
      )}
    </Menu>
  )
}

export default FeatureActionsMenu
